import iwm_old from "./assets/old-1024.png";
import iwm_new from "./assets/new-1024.png";
import centrix from "./assets/centrix-long-white.svg";
import weightron from "./assets/weightron-white.svg";

import faAngleRight from "./assets/icon/angle-right-regular-full.svg";
import faExternalLink from "./assets/icon/arrow-up-right-from-square-regular-full.svg";

import "./App.css";

function App() {
  return (
    <div className="w-[100dvw] min-h-[100dvh] overflow-visible bg-clip-border">
      <Background />

      <div className="absolute bottom-none top-3 left-2">
        <a href="https://centrix.world">
          <img
            src={centrix}
            className="w-[40vw] md:w-[30vw] lg:w-[20vw]"
            alt="Centrix Logo"
          />
        </a>
      </div>

      <div className="absolute top-0 right-0">
        <a href="https://weightron.com">
          <img
            src={weightron}
            className="w-[40vw] md:w-[30vw] lg:w-[20vw]"
            alt="Weightron Logo"
          />
        </a>
      </div>

      <div className="flex flex-col items-center justify-center w-[100dvw] min-h-[100dvh] py-20 z-10">
        <div className="flex flex-col rounded-[1.4rem] center-box shadow-xl w-5/6 md:w-[46rem]">
          {/*  */}
          <div className="flex flex-col gap-2 my-8 pl-6 pr-6 md:my-12 md:pl-12 md:pr-8">
            <h1 className="text-4xl font-bold text-slate-800">
              IWM has moved to Centrix.
            </h1>
            <h4 className="flex flex-col md:flex-row items-center text-xl font-normal text-slate-500">
              You can now access IWM at{" "}
              <a
                href="https://go.centrix.world"
                className="inline rounded-full mx-2 px-3.5 pt-0.5 pb-1 text-white bg-slate-500 hover:bg-slate-600"
              >
                go.centrix.world
                <img
                  src={faExternalLink}
                  className="h-4 inline ml-2 pb-0.5"
                  alt="External Link Icon"
                />
              </a>
            </h4>
          </div>
          {/*  */}
          <div className="flex flex-row justify-center items-center gap-0 md:gap-8">
            <a href="https://go.centrix.world">
              <img
                src={iwm_old}
                className="rounded-base p-6 bg-white h-[8rem] md:h-[16rem]"
                alt="Old IWM Logo"
              />
            </a>

            <img
              src={faAngleRight}
              className="w-[4rem] text-slate-400"
              alt="Right Arrow Icon"
            />

            <a href="https://go.centrix.world">
              <img
                src={iwm_new}
                className="rounded-base h-[8rem] md:h-[16rem]"
                alt="New IWM Logo"
              />
            </a>
          </div>
          {/*  */}
          <div className="flex items-center justify-center mt-8">
            <a
              href="https://go.centrix.world"
              className="inline rounded-full mx-2 px-3.5 pt-0.5 pb-1 text-white bg-slate-500 hover:bg-slate-600"
            >
              go.centrix.world
              <img
                src={faExternalLink}
                className="h-4 inline ml-2 pb-0.5"
                alt="External Link Icon"
              />
            </a>
          </div>
          <div className="flex flex-col text-xs font-normal text-slate-500 gap-2 mt-8 mb-12 px-6 md:mt-8 md:mb-12 md:px-12">
            <p>
              Customers of Weightron Bilanciai Limited with an active IWM
              (iwm.winweigh.com) subscription have been contacted prior to the
              retirement of this service. All data stored/accessed via this
              service has been migrated to the Centrix platform during your
              system upgrade. All user accounts associated with your IWM
              (iwm.winweigh.com) system have been invited to the Centrix
              platform during your system upgrade.
            </p>
            <p>
              If you are unsure about the above, have questions regarding this
              transition, or your system hasn't yet been transferred, please
              contact{" "}
              <a href="mailto:support@weightroncb.co.uk" className="underline">
                support@weightroncb.co.uk
              </a>
              .
            </p>
            {/* <span className="bg-red-500 sm:bg-green-500 md:bg-blue-500 lg:bg-yellow-500">
              size
            </span> */}
          </div>
        </div>
        <div className="px-12 pt-2 text-center text-xs text-slate-500">
          Copyright © Weightron Bilanciai Limited 2021-
          {new Date().getFullYear()}. All Rights Reserved. Registered Number
          02154099.
        </div>
      </div>
    </div>
  );
}

function Background() {
  return (
    <svg
      preserveAspectRatio="xMidYMid slice"
      viewBox="10 10 80 80"
      className="-z-10 bg-clip-border"
    >
      <path
        fill="#1398E2"
        class="out-top"
        d="M37-5C25.1-14.7,5.7-19.1-9.2-10-28.5,1.8-32.7,31.1-19.8,49c15.5,21.5,52.6,22,67.2,2.3C59.4,35,53.7,8.5,37-5Z"
      />
      <path
        fill="#2D388A"
        class="in-top"
        d="M20.6,4.1C11.6,1.5-1.9,2.5-8,11.2-16.3,23.1-8.2,45.6,7.4,50S42.1,38.9,41,24.5C40.2,14.1,29.4,6.6,20.6,4.1Z"
      />
      <path
        fill="#164292"
        class="out-bottom"
        d="M105.9,48.6c-12.4-8.2-29.3-4.8-39.4.8-23.4,12.8-37.7,51.9-19.1,74.1s63.9,15.3,76-5.6c7.6-13.3,1.8-31.1-2.3-43.8C117.6,63.3,114.7,54.3,105.9,48.6Z"
      />
      <path
        fill="#819BCF"
        class="in-bottom"
        d="M102,67.1c-9.6-6.1-22-3.1-29.5,2-15.4,10.7-19.6,37.5-7.6,47.8s35.9,3.9,44.5-12.5C115.5,92.6,113.9,74.6,102,67.1Z"
      />
    </svg>
  );
}

export default App;
